/**
 * FeedPeopleYouMayKnow.js — EcoScienceInnova
 * Sidebar widget: suggested people to connect with.
 *
 * Props:
 *  - people:  [{ id, name, role }]
 *  - onAdd:   (personId) => void
 *  - title:   string
 */
import React from 'react';
import { FaUserPlus } from 'react-icons/fa';
import FeedAvatar from './FeedAvatar';
import FeedSidebarCard from './FeedSidebarCard';
import './feed.shared.css';

const FeedPeopleYouMayKnow = ({
    people = [],
    onAdd,
    title = 'Personas que podrías conocer',
}) => {
    return (
        <FeedSidebarCard title={title}>
            <div className="feed-widget-scroll">
                {people.map(p => (
                    <div key={p.id} className="feed-person-item">
                        <FeedAvatar name={p.name} src={p.photo} size={38} />
                        <div className="feed-person-info">
                            <p className="feed-person-name">{p.name}</p>
                            <p className="feed-person-role">{p.role}</p>
                        </div>
                        <button
                            className="feed-add-btn"
                            title={`Conectar con ${p.name}`}
                            onClick={() => onAdd?.(p.id)}
                        >
                            <FaUserPlus style={{ color: '#FF6600' }} />
                        </button>
                    </div>
                ))}
            </div>
        </FeedSidebarCard>
    );
};

export default FeedPeopleYouMayKnow;
